module.exports = __webpack_public_path__ + "img/Neuroscience & Neuropsychiatry.e7b56c4e.jpg";